import CommonService from '../../../services/common-api-service';

export default class LoginApis {
    cs;
    constructor() {
        this.cs = new CommonService();
    }



    loginUser = userInfo => this.cs.httpConnection(`/Auth/Login`, 'authLogin', userInfo)
  
    checkLoginStatus = () => this.cs.httpConnection(`/Auth/CheckLoginStatus`, 'authLoginCheck');  

    logoutUser = () => this.cs.httpConnection(`/Auth/Logout`, 'authLogout');

    sendPasswordResetCode = userInfo => this.cs.httpConnection(`/UserManagement/SendPasswordResetCode`, 'authLogin', userInfo);

    passwordResetWToken = userInfo => this.cs.httpConnection(`/UserManagement/PasswordResetWToken`,'authLogin', userInfo);
    // getMessage = () => this.cs.httpConnection(`/BroadcastMessage/GetMessages`, 'get');
    // getLocation = locationNumber => this.cs.httpConnection(`/Location/GetLocationList/10345`, 'get');
}